var lastWidth = window.innerWidth;
var resizeTimeout;
function resizeFlickity() {
  // Only trigger if width has changed
  if (window.innerWidth === lastWidth) return;
  lastWidth = window.innerWidth;

  // toggle .flickity('resize') on window resize
  clearTimeout(resizeTimeout);
  resizeTimeout = setTimeout(function () {
    // find everyelement that has a property data-flickity={...}
    let allFlickity = document.querySelectorAll('[data-flickity]');
    if (!allFlickity) return;

    allFlickity.forEach(function (element) {
      Flickity.data(element)?.destroy();
      new Flickity(element, JSON.parse(element.getAttribute('data-flickity')));
    });
  }, 250);
}

theme.DOMready(function () {
  window.addEventListener('resize', resizeFlickity);
  document.addEventListener('shopify:section:load', resizeFlickity);
});
